/** Static copy + timing for the six "Getting started" steps. Shared by the step
 * list (left rail), the detail-panel header, and the progress math. Order is
 * authoritative — indices line up with the progress store's `done[]`. */
export interface OnboardingStepMeta {
  key: string;
  /** Label in the left step list. */
  listTitle: string;
  /** Headline in the detail panel. */
  detailTitle: string;
  /** Sub-copy in the detail panel. */
  detailDescription: string;
  /** Estimated minutes — feeds "About N minutes" and "N min left". */
  minutes: number;
  /** Extra hint shown on a pending step's caption (e.g. "needs your IRS login"). */
  durationHint?: string;
}

export const ONBOARDING_STEPS: OnboardingStepMeta[] = [
  {
    key: "company",
    listTitle: "Company details",
    detailTitle: "Tell us about your firm.",
    detailDescription:
      "Your firm's contact details and address appear on every letter, invoice and IRS form you generate.",
    minutes: 2,
  },
  {
    key: "branding",
    listTitle: "Logo & brand colour",
    detailTitle: "Make it unmistakably yours.",
    detailDescription:
      "Upload your logo and pick an accent colour — they land on letters, invoices and the client portal.",
    minutes: 2,
  },
  {
    key: "signature",
    listTitle: "Signature & letterhead",
    detailTitle: "Sign once. Every letter carries it.",
    detailDescription:
      "Your signature goes on engagement letters, IRS responses and POA cover pages — drawn, typed or uploaded.",
    minutes: 2,
  },
  {
    key: "portal",
    listTitle: "Client portal",
    detailTitle: "Give clients a branded portal.",
    detailDescription:
      "A secure self-service portal where clients upload documents and follow their case. Optional — configure it anytime.",
    minutes: 2,
  },
  {
    key: "eservices",
    listTitle: "Connect IRS e-Services",
    detailTitle: "Connect to IRS e-Services.",
    detailDescription:
      "Pull transcripts and monitor CAF status using a CAF-holding practitioner's e-Services login.",
    minutes: 3,
    durationHint: "needs your IRS login",
  },
  {
    key: "team",
    listTitle: "Invite your team",
    detailTitle: "Bring your team in.",
    detailDescription:
      "Add teammates so they can work cases alongside you. Optional if it's just you for now.",
    minutes: 1,
    durationHint: "optional if it's just you",
  },
];
